module.exports = __webpack_public_path__ + "img/Referenzen_Security12.92b88e72.jpg";